import React, { useState, useEffect } from 'react';
import {
  Container,
  Box,
  Typography,
  Paper,
  Tabs,
  Tab,
  Button,
  Alert
} from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import EmployeeList from '../components/AccessManagement/EmployeeList';
import AccessMatrix from '../components/AccessManagement/AccessMatrix';
import AuditLogs from '../components/AccessManagement/AuditLogs';
import Dashboard from '../components/AccessManagement/Dashboard';
import EmployeeDialog from '../components/AccessManagement/EmployeeDialog';
import { employeeApi } from '../services/accessApi';

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`access-tabpanel-${index}`}
      aria-labelledby={`access-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
}

export default function AccessManagement() {
  const [tabValue, setTabValue] = useState(0);
  const [employeeDialogOpen, setEmployeeDialogOpen] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [alert, setAlert] = useState({ show: false, message: '', severity: 'success' });

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleAddEmployee = () => {
    setSelectedEmployee(null);
    setEmployeeDialogOpen(true);
  };

  const handleEditEmployee = (employee) => {
    setSelectedEmployee(employee);
    setEmployeeDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setEmployeeDialogOpen(false);
    setSelectedEmployee(null);
  };

  const handleSaveEmployee = async (employeeData) => {
    try {
      if (selectedEmployee) {
        await employeeApi.update(selectedEmployee._id, employeeData);
        setAlert({ show: true, message: 'Employee updated successfully', severity: 'success' });
      } else {
        await employeeApi.create(employeeData);
        setAlert({ show: true, message: 'Employee created successfully', severity: 'success' });
      }
      handleCloseDialog();
      // Refresh the list
      window.location.reload();
    } catch (error) {
      setAlert({
        show: true,
        message: error.response?.data?.message || 'Error saving employee',
        severity: 'error'
      });
    }
  };

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h4" component="h1">
          IT Access & License Management
        </Typography>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={handleAddEmployee}
        >
          Add Employee
        </Button>
      </Box>

      {alert.show && (
        <Alert
          severity={alert.severity}
          onClose={() => setAlert({ ...alert, show: false })}
          sx={{ mb: 2 }}
        >
          {alert.message}
        </Alert>
      )}

      <Paper sx={{ width: '100%' }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label="Dashboard" />
          <Tab label="Employees" />
          <Tab label="Access Matrix" />
          <Tab label="Audit Logs" />
        </Tabs>

        <TabPanel value={tabValue} index={0}>
          <Dashboard />
        </TabPanel>

        <TabPanel value={tabValue} index={1}>
          <EmployeeList onEditEmployee={handleEditEmployee} />
        </TabPanel>

        <TabPanel value={tabValue} index={2}>
          <AccessMatrix />
        </TabPanel>

        <TabPanel value={tabValue} index={3}>
          <AuditLogs />
        </TabPanel>
      </Paper>

      <EmployeeDialog
        open={employeeDialogOpen}
        employee={selectedEmployee}
        onClose={handleCloseDialog}
        onSave={handleSaveEmployee}
      />
    </Container>
  );
}
